import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const assignmentLocaleModule: LocaleModule = {
  name: "assignment",
  messages: { en: en, it: it },
};
